module.exports = __webpack_public_path__ + "img/x-svgrepo-com.5b748be0.svg";